<template>
  <div>
    <b-container>
      <b-row align-v="center" align-h="center" class="mb-4">
        <b-col lg="8">
          <h2 class="h3-semibold-black mb-2">Sentiamoci!</h2>
          <p class="p-medium-gray-600 mb-4">Se hai qualche dubbio o domanda, contattaci! Ti aiuteremo nella scelta delle
            rata Serena perfetta per te!</p>

          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form @submit.stop.prevent="handleSubmit(sendForm)">
              <div class="row">
                <div class="col-lg-6">
                  <validation-provider
                      name="Nome"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-input v-model="user.first_name" type="text" class="form-control form-control-gray-900"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-1-live-feedback"
                                    placeholder="Nome"></b-form-input>
                      <b-form-invalid-feedback id="input-1-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
                <div class="col-lg-6">
                  <validation-provider
                      name="Cognome"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-input v-model="user.last_name" type="text" class="form-control form-control-gray-900"
                                    :state="getValidationState(validationContext)"
                                    aria-describedby="input-lastname-live-feedback"
                                    placeholder="Cognome"></b-form-input>
                      <b-form-invalid-feedback id="input-lastname-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
                <div class="col-lg-12">
                  <validation-provider
                      name="Messaggio"
                      :rules="{ required: true, min: 3 }"
                      v-slot="validationContext"
                  >
                    <div class="form-group">
                      <b-form-textarea
                          class="form-control form-control-gray-900"
                          :state="getValidationState(validationContext)"
                          aria-describedby="input-2-live-feedback"
                          v-model="user.message" required
                          placeholder="Messaggio"
                          rows="3" max-rows="6"
                      ></b-form-textarea>
                      <b-form-invalid-feedback id="input-2-live-feedback">{{
                          validationContext.errors[0]
                        }}
                      </b-form-invalid-feedback>
                    </div>
                  </validation-provider>
                </div>
              </div>

              <label>Come preferisci essere contattato?</label>
              <div class="row">
                <div class="col-lg-12">
                  <b-form-group>
                    <b-input-group>
                      <b-form-select v-model="user.contactType" :options="contactOptions"
                                     :class="{isPlaceholder: user.contactType == null}"
                                     class="form-control form-control-gray-900" required>
                        <template #first>
                          <b-form-select-option :value="null" disabled>Preferisco essere contattato tramite...*
                          </b-form-select-option>
                        </template>
                      </b-form-select>
                    </b-input-group>
                  </b-form-group>
                </div>

                <div class="col-lg-12">
                  <template v-if="user.contactType=='email'">
                    <p class="p-medium-gray-600 mb-1">Inserisci la tua mail, ti ricontatteremo il prima possibile.</p>
                    <validation-provider
                        name="Email"
                        :rules="{ required: true, min: 3, email: true }"
                        v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-input-group class="mb-2">
                          <b-form-input v-model="user.email" type="email" class="form-control form-control-gray-900"
                                        :state="getValidationState(validationContext)"
                                        aria-describedby="input-3-live-feedback"
                                        placeholder="Email *" required></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-3-live-feedback">{{
                            validationContext.errors[0]
                          }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </template>

                  <template v-else-if="user.contactType=='phone'">
                    <p class="p-medium-gray-600 mb-1">Inserisci numero di telefono, data e fascia oraria preferita,
                      cercheremo di contattarti come da tue indicazioni.</p>
                    <validation-provider
                        name="Telefono"
                        :rules="{ required: true, min: 6 }"
                        v-slot="validationContext"
                    >
                      <b-form-group>
                        <b-input-group class="mb-2">
                          <b-form-input v-model="user.telefono" type="tel" class="form-control form-control-gray-900"
                                        :state="getValidationState(validationContext)"
                                        aria-describedby="input-4-live-feedback"
                                        placeholder="Telefono *" required></b-form-input>
                        </b-input-group>
                        <b-form-invalid-feedback id="input-4-live-feedback">{{
                            validationContext.errors[0]
                          }}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                    <b-row>
                      <b-col lg="6">
                        <validation-provider
                            name="Data"
                            :rules="{ required: true }"
                            v-slot="validationContext"
                        >
                          <div class="form-group">
                            <b-form-datepicker v-model="user.data" class="form-control form-control-gray-900"
                                               :state="getValidationState(validationContext)"
                                               aria-describedby="input-data-live-feedback"
                                               :min="minDate"
                                               :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                               locale="it" placeholder="Data *" :hide-header="true"></b-form-datepicker>
                            <b-form-invalid-feedback id="input-data-live-feedback">{{
                                validationContext.errors[0]
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </validation-provider>
                      </b-col>
                      <b-col lg="6">
                        <validation-provider
                            name="Data"
                            :rules="{ required: true }"
                            v-slot="validationContext"
                        >
                          <div class="form-group">
                            <b-form-select v-model="user.ora" :options="oraOptions"
                                           :class="{isPlaceholder: user.ora == null}"
                                           class="form-control form-control-gray-900" required>
                              <template #first>
                                <b-form-select-option :value="null" disabled>Ora *
                                </b-form-select-option>
                              </template>
                            </b-form-select>
                            <b-form-invalid-feedback id="input-data-live-feedback">{{
                                validationContext.errors[0]
                              }}
                            </b-form-invalid-feedback>
                          </div>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </template>

                </div>
              </div>

              <b-form-group class="form-check" :state="stateCheck">
                <input type="checkbox" v-model="user.privacy" :value="true" class="form-check-input"
                       id="privacyCheck"
                       required>
                <label class="form-check-label h8-regular-black" for="privacyCheck">
                  Acconsento al trattamento dei miei dati. Consulta la <a href="https://www.sgrlucegas.com/privacy-policy/" class="h8-regular-azure-underline" target="_blank">Privacy Policy</a>.</label>
              </b-form-group>

              <button type="submit" class="button-azure-rounded full-width" :disabled="formDisabled">
                INVIA
              </button>
              <p class="recaptcha-disclaimer h8-regular-gray-600 mt-2 mb-0">
                Questo sito è protetto da reCAPTCHA e si applicano la
                <a href="https://policies.google.com/privacy" class="h8-regular-azure-underline" target="_blank" rel="noopener">Privacy Policy</a>
                e i <a href="https://policies.google.com/terms" class="h8-regular-azure-underline" target="_blank" rel="noopener">Termini di servizio</a>
                di Google.
              </p>
            </b-form>
          </validation-observer>

        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import { RECAPTCHA_ACTIONS, getRecaptchaToken } from '@/config/recaptcha';

export default {
  name: 'FormHelp',
  components: {},
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    today.setDate(today.getDate() + 1)
    return {
      minDate: today,
      localOptions: null,
      webPath: process.env.VUE_APP_WEB_PATH,

      contactOptions: [
        {value: 'email', text: 'Email'},
        {value: 'phone', text: 'Telefono'},
      ],
      oraOptions: [
        {value: 'morning', text: 'Mattina (8:30-12:30)'},
        {value: 'afternoon', text: 'Pomeriggio (14:00-17:00)'},
      ],
      user: {
        city: '',
        first_name: '',
        last_name: '',
        message: '',
        contactType: null,
        email: '',
        telefono: '',
        data: null,
        ora: null,
        privacy: null,
      }
    }
  },
  props: {},
  computed: {
    formDisabled() {
      return this.user.first_name.length < 1
          || this.user.last_name.length < 1
          || this.user.message.length < 1
          || (this.user.contactType == 'email' && this.user.email.length < 1)
          || (this.user.contactType == 'phone' && (this.user.telefono.length < 1 || this.user.data == null || this.user.ora == null))
          || !this.user.privacy
    },
    stateCheck: function () {
      return this.user.privacy;
    }
  },
  created() {
    this.localOptions = JSON.parse(sessionStorage.getItem('options'));
    this.city = this.localOptions.comune;

    if(typeof window.fbq != 'undefined') {
      this.trackFbViewContent('configuratore_serena', 'richiesta-aiuto');
    }
  },
  mounted() {
  },
  methods: {
    getValidationState({dirty, validated, valid = null}) {
      return dirty || validated ? valid : null;
    },
    async sendForm() {
      let that = this;
      if (!that.user.privacy) return false;
      that.$root.loading = true;

      let params = {
        customer: {
          Firstname: that.user.first_name,
          Lastname: that.user.last_name,
          Type: that.user.contactType,
          Message: that.user.message,
          City: that.city
        },
      }
      if(that.user.contactType == 'phone'){
        params.customer['Phone'] = that.user.telefono;
        params.customer['Date'] = that.user.data;
        params.customer['Time'] = that.user.ora;
      }else{
        params.customer['Email'] = that.user.email;
      }

      params.recaptcha_action = RECAPTCHA_ACTIONS.SEND_HELP;
      params.recaptcha_token = await getRecaptchaToken(RECAPTCHA_ACTIONS.SEND_HELP);

      that.axios.post(that.webPath + 'wp-admin/admin-ajax.php?action=relax_send_email_help', params)
          .then((response) => {
            let data = that.decryptAES(response.data);
            if ((typeof data.error !== 'undefined' && data.error) || !data.success) {
              that.showAlertModal(data.message)
              that.$root.loading = false;
            } else if (data.success) {
              if(typeof window.fbq != 'undefined') {
                this.trackFbLead('configuratore_serena', 'richiesta-aiuto');
              }
              if (typeof window.gtag !== 'undefined') {
                if (that.user.telefono.length > 0)
                  window.gtag('event', 'contatto', { 'event_category': 'configuratore-serena', 'event_label': 'richiesta-aiuto' });
                else
                  window.gtag('event', 'lead', { 'event_category': 'configuratore-serena', 'event_label': 'richiesta-aiuto' });
              }
              setTimeout(() => {
                that.$router.push({name: 'message-sent'});
              }, 1000);
            }
          })
          .catch((error) => {
            this.captureExceptionSentry(error);
            let message = "Qualcosa è andato storto, riprovare più tardi."
            this.showAlertModal(message)
            this.$root.loading = false;
          })
    }
  },
}
</script>

<style scoped lang="scss">
button[type="submit"] {
  font-size: 18px;
}
</style>